import React from 'react';

export const DisplayFormikState = props =>
  <div style={{ margin: '1rem 0' }}>
    <h3 style={{ fontFamily: 'monospace' }} />
    <pre
      style={{
        background: '#f6f8fa',
        fontSize: '.65rem',
        padding: '.5rem',
      }}
    >
      <strong>props</strong> ={' '}
      {JSON.stringify(props, null, 2)}
    </pre>
  </div>;

export const DisplayState = props =>
  <div style={{ margin: '1rem 0' }}>
    <h3 style={{ fontFamily: 'monospace' }} />
    <pre
      style={{
        background: '#f6f8fa',
        fontSize: '.65rem',
        padding: '.5rem',
      }}
    >
      <strong>props</strong> ={' '}
      {JSON.stringify(props, null, 2)}
    </pre>
  </div>;

export const AmeliaCountries = [
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ABW",
    "code": "ABW",
    "name": "Aruba",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ABW/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/AFG",
    "code": "AFG",
    "name": "Afghanistan",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/AFG/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/AGO",
    "code": "AGO",
    "name": "Angola",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/AGO/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/AIA",
    "code": "AIA",
    "name": "Anguilla",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/AIA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ALB",
    "code": "ALB",
    "name": "Albania",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ALB/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/AND",
    "code": "AND",
    "name": "Andorra",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/AND/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ANT",
    "code": "ANT",
    "name": "Netherlands Antilles",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ANT/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ARE",
    "code": "ARE",
    "name": "United Arab Emirates",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ARE/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ARG",
    "code": "ARG",
    "name": "Argentina",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ARG/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ARM",
    "code": "ARM",
    "name": "Armenia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ARM/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ASM",
    "code": "ASM",
    "name": "American Samoa",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ASM/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ATA",
    "code": "ATA",
    "name": "Antarctica",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ATA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ATF",
    "code": "ATF",
    "name": "French Southern Terr",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ATF/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ATG",
    "code": "ATG",
    "name": "Antigua",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ATG/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/AUS",
    "code": "AUS",
    "name": "Australia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/AUS/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/AUT",
    "code": "AUT",
    "name": "Austria",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/AUT/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/AZE",
    "code": "AZE",
    "name": "Azerbaijan",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/AZE/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BDI",
    "code": "BDI",
    "name": "Burundi",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BDI/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BEL",
    "code": "BEL",
    "name": "Belgium",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BEL/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BEN",
    "code": "BEN",
    "name": "Benin",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BEN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BFA",
    "code": "BFA",
    "name": "Burkina Faso",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BFA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BGD",
    "code": "BGD",
    "name": "Bangladesh",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BGD/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BGR",
    "code": "BGR",
    "name": "Bulgaria",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BGR/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BHR",
    "code": "BHR",
    "name": "Bahrain",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BHR/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BHS",
    "code": "BHS",
    "name": "Bahamas",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BHS/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BIH",
    "code": "BIH",
    "name": "Bosnia Herzegovina",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BIH/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BLR",
    "code": "BLR",
    "name": "Belarus",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BLR/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BLZ",
    "code": "BLZ",
    "name": "Belize",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BLZ/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BMU",
    "code": "BMU",
    "name": "Bermuda",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BMU/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BOL",
    "code": "BOL",
    "name": "Bolivia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BOL/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BRA",
    "code": "BRA",
    "name": "Brazil",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BRA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BRB",
    "code": "BRB",
    "name": "Barbados",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BRB/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BRN",
    "code": "BRN",
    "name": "Brunei",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BRN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BTN",
    "code": "BTN",
    "name": "Bhutan",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BTN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BVT",
    "code": "BVT",
    "name": "Bouvet Island",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BVT/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BWA",
    "code": "BWA",
    "name": "Botswana",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/BWA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CAF",
    "code": "CAF",
    "name": "Central African Repu",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CAF/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CAN",
    "code": "CAN",
    "name": "Canada",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CAN/provinces/BC",
        "code": "BC",
        "name": "British Columbia"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CAN/provinces/AB",
        "code": "AB",
        "name": "Alberta"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CAN/provinces/SK",
        "code": "SK",
        "name": "Saskatchewan"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CAN/provinces/MB",
        "code": "MB",
        "name": "Manitoba"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CAN/provinces/ON",
        "code": "ON",
        "name": "Ontario"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CAN/provinces/QC",
        "code": "QC",
        "name": "Quebec"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CAN/provinces/NB",
        "code": "NB",
        "name": "New Brunswick"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CAN/provinces/PEI",
        "code": "PEI",
        "name": "Prince Edward Island"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CAN/provinces/NS",
        "code": "NS",
        "name": "Nova Scotia"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CAN/provinces/NF",
        "code": "NF",
        "name": "Newfoundland"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CAN/provinces/YK",
        "code": "YK",
        "name": "Yukon Territory"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CAN/provinces/NWT",
        "code": "NWT",
        "name": "Northwest Territories"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CAN/provinces/NU",
        "code": "NU",
        "name": "Nunavut"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CAN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CCK",
    "code": "CCK",
    "name": "Cocs (Keeling) Islan",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CCK/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CHE",
    "code": "CHE",
    "name": "Switzerland",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CHE/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CHN",
    "code": "CHN",
    "name": "China",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CHN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CIV",
    "code": "CIV",
    "name": "Cote D'lvoire",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CIV/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CMR",
    "code": "CMR",
    "name": "Cameroon",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CMR/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/COD",
    "code": "COD",
    "name": "Congo",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/COD/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/COG",
    "code": "COG",
    "name": "Rep of Congo",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/COG/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/COK",
    "code": "COK",
    "name": "Cook Island",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/COK/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/COL",
    "code": "COL",
    "name": "Colombia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/COL/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/COM",
    "code": "COM",
    "name": "Comoros",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/COM/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CPV",
    "code": "CPV",
    "name": "Cape Verde",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CPV/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CRI",
    "code": "CRI",
    "name": "Costa Rica",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CRI/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CUBA",
    "code": "CUBA",
    "name": "Cuba",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CUBA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CYM",
    "code": "CYM",
    "name": "Cayman Islands",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CYM/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CYP",
    "code": "CYP",
    "name": "Cyprus",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CYP/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CZE",
    "code": "CZE",
    "name": "Czech Republic",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/CZE/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/DEU",
    "code": "DEU",
    "name": "Germany",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/DEU/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/DHL",
    "code": "DHL",
    "name": "Chile",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/DHL/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/DJI",
    "code": "DJI",
    "name": "Djibouti",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/DJI/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/DMA",
    "code": "DMA",
    "name": "Dominica",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/DMA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/DNK",
    "code": "DNK",
    "name": "Denmark",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/DNK/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/DOM",
    "code": "DOM",
    "name": "Dominican Republic",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/DOM/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/DZA",
    "code": "DZA",
    "name": "Algeria",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/DZA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ECE",
    "code": "ECE",
    "name": "Ecuador",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ECE/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/EGY",
    "code": "EGY",
    "name": "Egypt",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/EGY/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ERI",
    "code": "ERI",
    "name": "Eritrea",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ERI/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ESH",
    "code": "ESH",
    "name": "Western Sahara",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ESH/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ESP",
    "code": "ESP",
    "name": "Spain",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ESP/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/EST",
    "code": "EST",
    "name": "Estonia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/EST/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ETH",
    "code": "ETH",
    "name": "Ethiopia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ETH/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/FIN",
    "code": "FIN",
    "name": "Finland",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/FIN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/FJI",
    "code": "FJI",
    "name": "Fiji Islands",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/FJI/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/FLK",
    "code": "FLK",
    "name": "Falkland Islands",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/FLK/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/FLV",
    "code": "FLV",
    "name": "El Salvador",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/FLV/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/FRA",
    "code": "FRA",
    "name": "France",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/FRA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/FRO",
    "code": "FRO",
    "name": "Faroe Islands",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/FRO/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/FSM",
    "code": "FSM",
    "name": "Micronesia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/FSM/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GAB",
    "code": "GAB",
    "name": "Gabon",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GAB/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GBR",
    "code": "GBR",
    "name": "United Kingdom",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GBR/provinces/NA",
        "code": "NA",
        "name": "NA"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GBR/provinces/LO",
        "code": "LO",
        "name": "London"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GEO",
    "code": "GEO",
    "name": "Georgia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GEO/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GHA",
    "code": "GHA",
    "name": "Ghana",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GHA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GIB",
    "code": "GIB",
    "name": "Gibraltar",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GIB/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GIN",
    "code": "GIN",
    "name": "Guinea",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GIN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GLP",
    "code": "GLP",
    "name": "Guadeloupe",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GLP/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GMB",
    "code": "GMB",
    "name": "Gambia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GMB/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GNB",
    "code": "GNB",
    "name": "Guinea-Bissau",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GNB/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GNQ",
    "code": "GNQ",
    "name": "Equatorial Guinea",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GNQ/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GRC",
    "code": "GRC",
    "name": "Greece",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GRC/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GRD",
    "code": "GRD",
    "name": "Grenada",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GRD/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GRL",
    "code": "GRL",
    "name": "Greenland",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GRL/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GTM",
    "code": "GTM",
    "name": "Guatemala",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GTM/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GUF",
    "code": "GUF",
    "name": "French Guiana",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GUF/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GUM",
    "code": "GUM",
    "name": "Guam",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GUM/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GUY",
    "code": "GUY",
    "name": "Guyana",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/GUY/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/HKG",
    "code": "HKG",
    "name": "Hong Kong",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/HKG/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/HMD",
    "code": "HMD",
    "name": "Heard Island",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/HMD/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/HND",
    "code": "HND",
    "name": "Honduras",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/HND/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/HRV",
    "code": "HRV",
    "name": "Croatia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/HRV/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/HTI",
    "code": "HTI",
    "name": "Haiti",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/HTI/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/HUN",
    "code": "HUN",
    "name": "Hungary",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/HUN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/IAR",
    "code": "IAR",
    "name": "Yugoslavia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/IAR/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/IDN",
    "code": "IDN",
    "name": "Indonesia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/IDN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/IND",
    "code": "IND",
    "name": "India",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/IND/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/IOT",
    "code": "IOT",
    "name": "British Indian Ocean",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/IOT/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/IRL",
    "code": "IRL",
    "name": "Ireland",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/IRL/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/IRN",
    "code": "IRN",
    "name": "Iran",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/IRN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/IRQ",
    "code": "IRQ",
    "name": "Iraq",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/IRQ/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ISL",
    "code": "ISL",
    "name": "Iceland",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ISL/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ISR",
    "code": "ISR",
    "name": "Israel",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ISR/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ITA",
    "code": "ITA",
    "name": "Italy",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ITA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/JAM",
    "code": "JAM",
    "name": "Jamaica",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/JAM/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/JOR",
    "code": "JOR",
    "name": "Jordan",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/JOR/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/JPN",
    "code": "JPN",
    "name": "Japan",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/JPN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/KAZ",
    "code": "KAZ",
    "name": "Kazakhstan",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/KAZ/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/KEN",
    "code": "KEN",
    "name": "Kenya",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/KEN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/KGZ",
    "code": "KGZ",
    "name": "Kyrgyzstan",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/KGZ/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/KHM",
    "code": "KHM",
    "name": "Cambodia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/KHM/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/KIR",
    "code": "KIR",
    "name": "Kiribati",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/KIR/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/KNA",
    "code": "KNA",
    "name": "Saint Kitts and Nevi",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/KNA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/KOR",
    "code": "KOR",
    "name": "South Korea",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/KOR/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/KWT",
    "code": "KWT",
    "name": "Kuwait",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/KWT/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LAO",
    "code": "LAO",
    "name": "Laos PDRC",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LAO/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LBN",
    "code": "LBN",
    "name": "Lebanon",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LBN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LBR",
    "code": "LBR",
    "name": "Liberia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LBR/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LBY",
    "code": "LBY",
    "name": "Libyan Arab",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LBY/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LCA",
    "code": "LCA",
    "name": "Saint Lucia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LCA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LIE",
    "code": "LIE",
    "name": "Liechtenstein",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LIE/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LKA",
    "code": "LKA",
    "name": "Sri Lanka",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LKA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LSO",
    "code": "LSO",
    "name": "Lesotho",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LSO/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LTU",
    "code": "LTU",
    "name": "Lithuania",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LTU/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LUX",
    "code": "LUX",
    "name": "Luxembourg",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LUX/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LVA",
    "code": "LVA",
    "name": "Latvia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/LVA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MAC",
    "code": "MAC",
    "name": "Macau",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MAC/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MAR",
    "code": "MAR",
    "name": "Morocco",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MAR/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MBG",
    "code": "MBG",
    "name": "Madagascar",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MBG/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MCO",
    "code": "MCO",
    "name": "Monaco",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MCO/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MDA",
    "code": "MDA",
    "name": "Moldova Republic of",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MDA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MDV",
    "code": "MDV",
    "name": "Maldives",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MDV/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MEX",
    "code": "MEX",
    "name": "Mexico",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MEX/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MHL",
    "code": "MHL",
    "name": "Marshall Islands",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MHL/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MKD",
    "code": "MKD",
    "name": "Macedonia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MKD/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MLI",
    "code": "MLI",
    "name": "Mali",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MLI/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MLT",
    "code": "MLT",
    "name": "Malta",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MLT/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MMR",
    "code": "MMR",
    "name": "Myanmar",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MMR/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MNE",
    "code": "MNE",
    "name": "Montenegro",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MNE/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MNG",
    "code": "MNG",
    "name": "Mongolia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MNG/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MOZ",
    "code": "MOZ",
    "name": "Mozambique",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MOZ/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MRT",
    "code": "MRT",
    "name": "Mauritania",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MRT/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MTQ",
    "code": "MTQ",
    "name": "Martinique",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MTQ/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MUS",
    "code": "MUS",
    "name": "Mauritius",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MUS/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MWI",
    "code": "MWI",
    "name": "Malawi",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MWI/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MYS",
    "code": "MYS",
    "name": "Malaysia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MYS/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MYT",
    "code": "MYT",
    "name": "Mayotte",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/MYT/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NA",
    "code": "NA",
    "name": "NA",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NAM",
    "code": "NAM",
    "name": "Namibia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NAM/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NCL",
    "code": "NCL",
    "name": "New Caledonia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NCL/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NER",
    "code": "NER",
    "name": "Niger",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NER/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NFK",
    "code": "NFK",
    "name": "Norfolk Island",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NFK/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NGA",
    "code": "NGA",
    "name": "Nigeria",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NGA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NIC",
    "code": "NIC",
    "name": "Nicaragua",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NIC/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NIU",
    "code": "NIU",
    "name": "Niue",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NIU/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NLD",
    "code": "NLD",
    "name": "Netherlands",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NLD/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NMP",
    "code": "NMP",
    "name": "Northern MarianaI",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NMP/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NOR",
    "code": "NOR",
    "name": "Norway",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NOR/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NPL",
    "code": "NPL",
    "name": "Nepal",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NPL/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NRU",
    "code": "NRU",
    "name": "Nauru",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NRU/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NZL",
    "code": "NZL",
    "name": "New Zealand",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/NZL/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/OMN",
    "code": "OMN",
    "name": "Oman",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/OMN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PAK",
    "code": "PAK",
    "name": "Pakistan",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PAK/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PAN",
    "code": "PAN",
    "name": "Panama",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PAN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PCN",
    "code": "PCN",
    "name": "Pitcairn Islands",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PCN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PER",
    "code": "PER",
    "name": "Peru",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PER/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PHL",
    "code": "PHL",
    "name": "Philippines",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PHL/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PLW",
    "code": "PLW",
    "name": "Palau",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PLW/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PNG",
    "code": "PNG",
    "name": "Papua New Guinea",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PNG/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/POL",
    "code": "POL",
    "name": "Poland",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/POL/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PRI",
    "code": "PRI",
    "name": "Puerto Rico",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PRI/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PRK",
    "code": "PRK",
    "name": "North Korea",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PRK/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PRT",
    "code": "PRT",
    "name": "Portugal",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PRT/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PRY",
    "code": "PRY",
    "name": "Paraguay",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PRY/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PSE",
    "code": "PSE",
    "name": "Palestinain Terr",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PSE/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PYF",
    "code": "PYF",
    "name": "French Polynesia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/PYF/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/QAT",
    "code": "QAT",
    "name": "Qatar",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/QAT/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/REU",
    "code": "REU",
    "name": "Reunion",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/REU/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ROU",
    "code": "ROU",
    "name": "Romania",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ROU/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/RUS",
    "code": "RUS",
    "name": "Russia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/RUS/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/RWA",
    "code": "RWA",
    "name": "Rwanda",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/RWA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SAU",
    "code": "SAU",
    "name": "Saudi Arabia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SAU/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SDN",
    "code": "SDN",
    "name": "Sudan",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SDN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SEN",
    "code": "SEN",
    "name": "Senegal",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SEN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SGP",
    "code": "SGP",
    "name": "Singapore",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SGP/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SGS",
    "code": "SGS",
    "name": "South Georgia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SGS/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SHN",
    "code": "SHN",
    "name": "Saint Helena",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SHN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SJN",
    "code": "SJN",
    "name": "Sval Vald and Jan Me",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SJN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SLB",
    "code": "SLB",
    "name": "Solomon Islands",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SLB/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SLE",
    "code": "SLE",
    "name": "Sierra Leone",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SLE/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SMR",
    "code": "SMR",
    "name": "San Marino",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SMR/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SOM",
    "code": "SOM",
    "name": "Somalia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SOM/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SPN",
    "code": "SPN",
    "name": "St Pierre & Miquelon",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SPN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SRB",
    "code": "SRB",
    "name": "Serbia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SRB/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/STP",
    "code": "STP",
    "name": "St Tome & Princip",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/STP/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SUR",
    "code": "SUR",
    "name": "Suriname",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SUR/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SVK",
    "code": "SVK",
    "name": "Slovakia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SVK/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SVN",
    "code": "SVN",
    "name": "Slovenia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SVN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SWE",
    "code": "SWE",
    "name": "Sweden",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SWE/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SWZ",
    "code": "SWZ",
    "name": "Swaziland",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SWZ/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SYC",
    "code": "SYC",
    "name": "Seychelles",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SYC/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SYR",
    "code": "SYR",
    "name": "Syrian Arab Republic",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/SYR/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TCA",
    "code": "TCA",
    "name": "Turks / Caicos Isl",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TCA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TCD",
    "code": "TCD",
    "name": "Chad",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TCD/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TGO",
    "code": "TGO",
    "name": "Togo",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TGO/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/THA",
    "code": "THA",
    "name": "Thailand",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/THA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TJK",
    "code": "TJK",
    "name": "Tajikistan",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TJK/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TKL",
    "code": "TKL",
    "name": "Tokelau",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TKL/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TKM",
    "code": "TKM",
    "name": "Turkmenistan",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TKM/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TLS",
    "code": "TLS",
    "name": "Timor Leste",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TLS/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TON",
    "code": "TON",
    "name": "Tonga",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TON/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TTO",
    "code": "TTO",
    "name": "Trinidad and Tobago",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TTO/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TUN",
    "code": "TUN",
    "name": "Tunisia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TUN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TUR",
    "code": "TUR",
    "name": "Turkey",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TUR/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TUV",
    "code": "TUV",
    "name": "Tuvalu",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TUV/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TWN",
    "code": "TWN",
    "name": "Taiwan",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TWN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TZA",
    "code": "TZA",
    "name": "Tanzania",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/TZA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/UGA",
    "code": "UGA",
    "name": "Uganda",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/UGA/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/UKR",
    "code": "UKR",
    "name": "Ukraine",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/UKR/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/UMI",
    "code": "UMI",
    "name": "US Minor Islands",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/UMI/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/URY",
    "code": "URY",
    "name": "Uruguay",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/URY/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA",
    "code": "USA",
    "name": "United States",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/NA",
        "code": "NA",
        "name": "NA"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/CA",
        "code": "CA",
        "name": "California"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/AL",
        "code": "AL",
        "name": "Alabama"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/AK",
        "code": "AK",
        "name": "Alaska"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/AZ",
        "code": "AZ",
        "name": "Arizona"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/AR",
        "code": "AR",
        "name": "Arkansas"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/CO",
        "code": "CO",
        "name": "Colorado"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/CT",
        "code": "CT",
        "name": "Connecticut"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/DE",
        "code": "DE",
        "name": "Delaware"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/FL",
        "code": "FL",
        "name": "Florida"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/GA",
        "code": "GA",
        "name": "Georgia"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/HI",
        "code": "HI",
        "name": "Hawaii"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/ID",
        "code": "ID",
        "name": "Idaho"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/IL",
        "code": "IL",
        "name": "Illinois"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/IN",
        "code": "IN",
        "name": "Indiana"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/IA",
        "code": "IA",
        "name": "Iowa"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/KS",
        "code": "KS",
        "name": "Kansas"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/KY",
        "code": "KY",
        "name": "Kentucky"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/LA",
        "code": "LA",
        "name": "Louisiana"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/ME",
        "code": "ME",
        "name": "Maine"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/MD",
        "code": "MD",
        "name": "Maryland"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/MA",
        "code": "MA",
        "name": "Massachusetts"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/MI",
        "code": "MI",
        "name": "Michigan"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/MN",
        "code": "MN",
        "name": "Minnesota"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/MS",
        "code": "MS",
        "name": "Mississippi"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/MO",
        "code": "MO",
        "name": "Missouri"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/MT",
        "code": "MT",
        "name": "Montana"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/NE",
        "code": "NE",
        "name": "Nebraska"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/NV",
        "code": "NV",
        "name": "Nevada"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/NH",
        "code": "NH",
        "name": "New Hampshire"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/NJ",
        "code": "NJ",
        "name": "New Jersey"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/NM",
        "code": "NM",
        "name": "New Mexico"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/NY",
        "code": "NY",
        "name": "New York"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/NC",
        "code": "NC",
        "name": "North Carolina"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/ND",
        "code": "ND",
        "name": "North Dakota"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/OH",
        "code": "OH",
        "name": "Ohio"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/OK",
        "code": "OK",
        "name": "Oklahoma"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/OR",
        "code": "OR",
        "name": "Oregon"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/PA",
        "code": "PA",
        "name": "Pennsylvania"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/RI",
        "code": "RI",
        "name": "Rhode Island"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/SC",
        "code": "SC",
        "name": "South Carolina"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/SD",
        "code": "SD",
        "name": "South Dakota"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/TN",
        "code": "TN",
        "name": "Tennessee"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/TX",
        "code": "TX",
        "name": "Texas"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/UT",
        "code": "UT",
        "name": "Utah"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/VT",
        "code": "VT",
        "name": "Vermont"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/VA",
        "code": "VA",
        "name": "Virginia"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/WA",
        "code": "WA",
        "name": "Washington"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/WV",
        "code": "WV",
        "name": "West Virginia"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/WI",
        "code": "WI",
        "name": "Wisconsin"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/USA/provinces/WY",
        "code": "WY",
        "name": "Wyoming"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/UZB",
    "code": "UZB",
    "name": "Uzbekistan",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/UZB/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VAT",
    "code": "VAT",
    "name": "Vatican City",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VAT/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VCT",
    "code": "VCT",
    "name": "St Vincent & Grenadi",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VCT/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VEN",
    "code": "VEN",
    "name": "Venezuela",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VEN/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VGB",
    "code": "VGB",
    "name": "Virgin Island Britis",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VGB/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VIR",
    "code": "VIR",
    "name": "Virgin Islands US",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VIR/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM",
    "code": "VNM",
    "name": "Vietnam",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/NA",
        "code": "NA",
        "name": "NA"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/SGN",
        "code": "SGN",
        "name": "Ho Chi Minh City"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/HAN",
        "code": "HAN",
        "name": "Ha Noi"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/DAD",
        "code": "DAD",
        "name": "Da Nang"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/HUI",
        "code": "HUI",
        "name": "Hue"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/AG",
        "code": "AG",
        "name": "An Giang"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/BRVT",
        "code": "BRVT",
        "name": "Ba Ria - Vung Tau"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/BL",
        "code": "BL",
        "name": "Bac Lieu"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/BK",
        "code": "BK",
        "name": "Bac Kan"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/BG",
        "code": "BG",
        "name": "Bac Giang"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/BN",
        "code": "BN",
        "name": "Bac Ninh"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/BT",
        "code": "BT",
        "name": "Ben Tre"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/BD",
        "code": "BD",
        "name": "Binh Duong"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/BDH",
        "code": "BDH",
        "name": "Binh Dinh"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/BP",
        "code": "BP",
        "name": "Binh Phuoc"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/BTN",
        "code": "BTN",
        "name": "Binh Thuan"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/CM",
        "code": "CM",
        "name": "Ca Mau"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/CB",
        "code": "CB",
        "name": "Cao Bang"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/CT",
        "code": "CT",
        "name": "Can Tho"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/DL",
        "code": "DL",
        "name": "Dac Lak"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/DN",
        "code": "DN",
        "name": "Dac Nong"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/DB",
        "code": "DB",
        "name": "Dien Bien"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/DNN",
        "code": "DNN",
        "name": "Dong Nai"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/DT",
        "code": "DT",
        "name": "Dong Thap"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/GL",
        "code": "GL",
        "name": "Gia Lai"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/HG",
        "code": "HG",
        "name": "Ha Giang"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/HN",
        "code": "HN",
        "name": "Ha Nam"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/HT",
        "code": "HT",
        "name": "Ha Tay"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/HTT",
        "code": "HTT",
        "name": "Ha Tinh"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/HD",
        "code": "HD",
        "name": "Hai Duong"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/HPH",
        "code": "HPH",
        "name": "Hai Phong"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/HGG",
        "code": "HGG",
        "name": "Hau Giang"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/HB",
        "code": "HB",
        "name": "Hoa Binh"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/HY",
        "code": "HY",
        "name": "Hung Yen"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/CXR",
        "code": "CXR",
        "name": "Khanh Hoa"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/KG",
        "code": "KG",
        "name": "Kien Giang"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/KTT",
        "code": "KTT",
        "name": "Kon Tum"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/LC",
        "code": "LC",
        "name": "Lai Chau"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/LD",
        "code": "LD",
        "name": "Lam Dong"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/LS",
        "code": "LS",
        "name": "Lang Son"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/LCC",
        "code": "LCC",
        "name": "Lao Cai"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/LA",
        "code": "LA",
        "name": "Long An"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/ND",
        "code": "ND",
        "name": "Nam Dinh"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/VII",
        "code": "VII",
        "name": "Nghe An"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/NB",
        "code": "NB",
        "name": "Ninh Binh"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/NT",
        "code": "NT",
        "name": "Ninh Thuan"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/PT",
        "code": "PT",
        "name": "Phu Tho"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/PY",
        "code": "PY",
        "name": "Phu Yen"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/QB",
        "code": "QB",
        "name": "Quang Binh"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/QN",
        "code": "QN",
        "name": "Quang Nam"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/QNN",
        "code": "QNN",
        "name": "Quang Ngai"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/QNI",
        "code": "QNI",
        "name": "Quang Ninh"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/QT",
        "code": "QT",
        "name": "Quang Tri"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/ST",
        "code": "ST",
        "name": "Soc Trang"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/SL",
        "code": "SL",
        "name": "Son La"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/TN",
        "code": "TN",
        "name": "Tay Ninh"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/TB",
        "code": "TB",
        "name": "Thai Binh"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/THN",
        "code": "THN",
        "name": "Thai Nguyen"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/THH",
        "code": "THH",
        "name": "Thanh Hoa"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/TG",
        "code": "TG",
        "name": "Tien Giang"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/TV",
        "code": "TV",
        "name": "Tra Vinh"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/TQ",
        "code": "TQ",
        "name": "Tuyen Quang"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/VL",
        "code": "VL",
        "name": "Vinh Long"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/VP",
        "code": "VP",
        "name": "Vinh Phuc"
      },
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VNM/provinces/YB",
        "code": "YB",
        "name": "Yen Bai"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VUT",
    "code": "VUT",
    "name": "Vanuatu",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/VUT/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/WLF",
    "code": "WLF",
    "name": "Wallis and Futuna",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/WLF/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/WSM",
    "code": "WSM",
    "name": "Samoa",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/WSM/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/YEM",
    "code": "YEM",
    "name": "Yemen",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/YEM/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ZAF",
    "code": "ZAF",
    "name": "South Africa",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ZAF/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ZMB",
    "code": "ZMB",
    "name": "Zambia",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ZMB/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  },
  {
    "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ZWE",
    "code": "ZWE",
    "name": "Zimbabwe",
    "provinces": [
      {
        "href": "https://vietjet-api.intelisystraining.ca/RESTv1/countries/ZWE/provinces/NA",
        "code": "NA",
        "name": "NA"
      }
    ]
  }
]